import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import Feather from '@expo/vector-icons/Feather';
import Ionicons from '@expo/vector-icons/Ionicons';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Paprika } from '../../styles/theme';

/**
 * The three reasons to create an account — the only explanatory copy on the
 * page. Rendered in the desktop brand panel and, on mobile, above the form
 * (variant="header" adds a hairline separator beneath).
 */
export const ReasonsList: React.FC<{ variant?: 'panel' | 'header' }> = ({ variant = 'panel' }) => {
  const { t } = useTranslation();

  const reasons = [
    { key: 'reason1', render: () => <MaterialCommunityIcons name="devices" size={20} color={Paprika.accent} /> },
    { key: 'reason2', render: () => <Feather name="bookmark" size={20} color={Paprika.accent} /> },
    { key: 'reason3', render: () => <Ionicons name="scan-outline" size={20} color={Paprika.accent} /> },
  ];

  return (
    <View style={[styles.list, variant === 'header' && styles.header]}>
      {reasons.map((r) => (
        <View key={r.key} style={styles.row}>
          <View style={styles.chip}>{r.render()}</View>
          <Text style={styles.label}>{t(`auth.${r.key}`)}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  list: {
    gap: 18,
  },
  header: {
    marginBottom: 26,
    paddingBottom: 24,
    borderBottomWidth: 1,
    borderBottomColor: Paprika.hairline,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
  },
  chip: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: Paprika.brandSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  label: {
    flex: 1,
    fontFamily: 'Inter-Regular',
    fontSize: 15,
    lineHeight: 20,
    color: Paprika.textSecondary,
  },
});
